<template>
  <div v-if="group">
    <div class="p-2 border-bottom">
      <roommate-group-header v-if="group" v-bind="group" />
    </div>
    <roommate-group-member-list v-if="group" v-bind="group" />
  </div>
  <h3 v-else style="text-align: center" class="text-muted my-3">
    No {{ capitalize(roommateTitle) }}s
  </h3>
</template>

<script setup lang="ts">
import capitalize from "lodash-es/capitalize";
import { inject } from "vue";

import { RoommateGroupType } from "../../../types";
import RoommateGroupHeader from "./RoommateGroupHeader.vue";
import RoommateGroupMemberList from "./RoommateGroupMemberList.vue";

interface Props {
  group: RoommateGroupType | null;
}

defineProps<Props>();

const roommateTitle = inject<string>("roommateTitle");
</script>

<style lang="scss" scoped>
@media screen and (max-width: 992px) {
  .action-button {
    margin-top: 10px;
  }
}
</style>
